import { config } from '@/constants/page.js'
import store from '@/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config[store.state.apiKey].serverUrl}`,
    timeout: 30000
  })

const demoApi = {
  loginOrRegis: (body) => {
    return instance().post('/api/demo/webchat/login-or-regis', body, {
      headers: {
        AUTHORIZATION: `${config[store.state.apiKey].auth}`
      }
    })
  }
}
export default demoApi
